<template>
  <modal
    v-on:close="close"
    :show.sync="show"
    type="notice"
    headerClasses="justify-content-center"
    modalClasses="modal-user-profile"
  >
    <h4 slot="header" class="title title-up">USER INFORMATION</h4>
    <hr />
    <div class="container">
        <div class="row">
          <div class="col-md-4">
            <base-input
              type="text"
              label="First Name"
              placeholder="First Name"
              v-model="user.firstName"
            >
            </base-input>
          </div>
          <div class="col-md-4">
            <base-input
              label="Middle Name"
              v-model="user.middleName"
              placeholder="Middle Name"
              addon-left-icon="tim-icons icon-single-02"
            ></base-input>
          </div>
          <div class="col-md-4">
            <base-input
              type="text"
              label="Last Name"
              placeholder="Last Name"
              v-model="user.lastName"
              addon-left-icon="tim-icons icon-single-02"
            >
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <base-input
              label="Title"
              :error="getError('title')"
              v-model="user.title"
              name="title"
              type="text"
              placeholder="Title"
              addon-left-icon="tim-icons icon-badge"
            ></base-input>
          </div>
          <div class="col-md-6">
            <base-input
              label="Phone Number"
              :error="getError('phoneNumber')"
              v-model="user.phoneNumber"
              name="phonenumber"
              type="phone"
              placeholder="Phone number"
              addon-left-icon="tim-icons icon-mobile"
            ></base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <base-input
              label="Email"
              v-model="user.email"
              name="email"
              placeholder="Email"
              addon-left-icon="tim-icons icon-email-85"
            ></base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <base-input
              disabled
              v-model="user.approvalStatusName"
              label="Status"
            >
            </base-input>
          </div>
          <div class="col-md-6">
            <base-input label="Approved By" :error="getError('approve')">
              <v-select
                v-model="user.approverId"
                :reduce="(user) => user.id"
                v-b-popover.hover.top="selectedSponserUserLabel"
                label="nameLabel"
                :options="sponsorUsers"
                placeholder="Select one"
              >
                <template v-slot:option="option">
                  {{ option.nameLabel }}
                </template></v-select
              >
            </base-input>
          </div>
        </div>
    </div>

      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <base-input label="Organization" :error="getError('organization')">
              <treeselect
                v-model="user.organizationId"
                class="select-primary"
                name="organization"
                :options="jointStaffOrganizations"
              />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <base-input label="Role(s)" :error="getError('roles')">
              <v-select
                v-model="user.roles"
                name="roles"
                multiple
                :reduce="(role) => role.name"
                label="name"
                :options="filteredRoles"
                placeholder="Select one"
              ></v-select>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <base-input label="Approval">
              <lock-button :id="userId"></lock-button>
              <approval-modal :id="userId" ref="approval"></approval-modal>
            </base-input>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 italics">
          <label for="LastLoginDate">{{ lastLoggedInInfo }} </label>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 italics">
          <label for="EmailConfirmation">{{ confirmedEmailInfo }} </label>
        </div>
      </div>
    <template slot="footer">
      <div class="container alert_footer">
        <base-button
          type="danger"
          class="alert_footer_button btn_extra_small btn_info mr-4"
          @click.native="close"
        >
          Close
        </base-button>
        <base-button
          type="primary"
          class="alert_footer_button btn_extra_small btn_info"
          @click.native="submit"
        >
          Save
        </base-button>
      </div>
    </template>
  </modal>
</template>

<script>
import LockButton from "./LockButton.vue";
import ApprovalModal from "./Approval.vue";
import Treeselect from "@riophae/vue-treeselect";
import { Select, Option } from "element-ui";
import { mapGetters, mapActions } from "vuex";
import { BaseButton, Modal } from "@/components";
import Util from "@/util/util";

import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "user-modal",
  components: {
    Modal,
    [Select.name]: Select,
    [Option.name]: Option, 
    BaseButton,
    ApprovalModal,
    LockButton,
    Treeselect,
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    ...mapGetters({
      user: "users/user",
      jointStaffOrganizations: "organization/jointStaffOrganizations",
      roles: "roles/userRoles",
      approvalStatuses: "approvalStatus/approvalStatuses",
      sponsorUsers: "users/sponsorUsers",
    }),
    userId(){
      return this.user.id;
    },
    isApprovedUser() {
      return this.user.approvalStatusId == 2 ? true : false;
    },
    filteredRoles() {
      if (this.user.approvalStatusId != 1) {
        return this.roles.filter((role) => {
          return role.name !== "Pending";
        });
      } else {
        return this.roles;
      }
    },
    lastLoggedInInfo() {
      return Util.isNullOrEmpty(this.user.lastLoginDate)
        ? `We do not have record of the last time ${this.user.firstName} logged in.`
        : `${this.user.firstName} last logged in on: ${Util.formatDateWithLocalTimezone(this.user.lastLoginDate)}`;
    },
    confirmedEmailInfo() {
      return this.user.emailConfirmed ? `${this.user.firstName}'s email IS confirmed.` : `${this.user.firstName}'s email is NOT confirmed.`;
    },
    selectedSponserUserLabel() {
      let selectedUser;
      if (this.user.approverId) {
        selectedUser = this.sponsorUsers.find(
          (user) => user.id === this.user.approverId
        );
      }
      return selectedUser ? selectedUser.nameLabel : "No user selected";
    },
  },

  methods: {
    ...mapActions({
      updateUser: "users/updateUserProfile",
      clearUser: "users/clearUser",
    }),
    close() {
      this.errors.clear();
      this.show = false;
      this.$refs.approval.close();
      this.clearUser();
    },
    open() {
      this.show = true;
    },
    submit(e) {
      let ctx = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          ctx.updateUser().then((response) => {
            ctx.errors.clear();
            ctx.show = false;
            //ctx.$emit("modal-closed");
          });
        }
      });
    },
    getError(fieldName) {
      return Util.transformValidationText(this.errors.first(fieldName));
    },
  },
};
</script>
